// @flow
/* eslint arrow-parens:0 */

import type { Action } from 'app/common/redux/types';

export type State = {
  showModal: boolean,
  showParentConsentModal: boolean,
};

const initialState = {
  showModal: false,
  showParentConsentModal: false,
};

const gdprModal = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'OPEN_GDPR_MODAL':
      return { showModal: true, showParentConsentModal: false };
    case 'CLOSE_GDPR_MODAL':
      return { showModal: false, showParentConsentModal: false };
    case 'OPEN_GDPR_PARENT_CONSENT_MODAL':
      return { showModal: true, showParentConsentModal: true };
    default:
      return state;
  }
};

export default gdprModal;
